import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  fetchVisitorTypes,
  fetchIdProofTypes,
  fetchMeetingVenues,
  insertAppointment,
  fetchNationality,
  fetchGateDetails,
  fetchBuildingsByGate,
} from "../../services/Api";
import Webcam from "react-webcam"; // Import react-webcam
import { User } from "react-feather"; // Import the User icon
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";
import * as mp from "@mediapipe/selfie_segmentation";
import { createWorker } from "tesseract.js";
import { axiosInstance } from "../../services/Api";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../Loader/loader";
import { FaceDetection } from "@mediapipe/face_detection";
import SignatureCanvas from 'react-signature-canvas';
// import { set } from "react-datepicker/dist/date_utils";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 18px 7px 33px;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Heading = styled.h1`
  font-size: 25px;
  font-family: "Segoe UI", Semibold;
  color: #2b3497;
  margin: 0;
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  width: 81px;
  height: 32px;
  border-radius: 7px;
  box-shadow: 0px 5px 10px #2b349754;
  color: white;
  font-size: 14px;
  border: none;
  cursor: pointer;
  font-family: "Segoe UI", Semibold;
`;

const ResetButton = styled(Button)`
  background-color: red;
`;

const SubmitButton = styled(Button)`
  background-color: #2b3497;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 9px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Card = styled.div`
  flex: 1;
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 27px;
  opacity: 1;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  font-family: "Segoe UI", Semibold;
  color: #000000;
  margin-bottom: 5px;
  font-weight: 600;
`;

const Asterisk = styled.span`
  color: red;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

const StyledDatePicker = styled(DatePicker)`
  width: 415px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    padding: 8px 0;
    border: none;
    font-family: "Segoe UI", Regular;
    background: transparent;
    border-bottom: 1px solid #2b3497;
    &:focus {
      outline: none;
      border-bottom: 2px solid #2b3497;
    }
  }
  @media (max-width: 1920px) {
    width: 745px;
  }
  @media (max-width: 1820px) {
    width: 689px;
  }
  @media (max-width: 1720px) {
    width: 644px;
  }
  @media (max-width: 1620px) {
    width: 587px;
  }
  @media (max-width: 1520px) {
    width: 587px;
  }
  @media (max-width: 1420px) {
    width: 487px;
  }
`;

const ProfileCard = styled(Card)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Circle = styled.div`
  width: 131px;
  height: 131px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
`;

const ProfileIcon = styled.div`
  width: 134px;
  height: 131px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;

const PlusIcon = styled.div`
  width: 47px;
  height: 23px;
  border-radius: 50%;
  position: absolute;
  right: 0;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #bfbfbf;
  font-size: 44px;
  font-weight: 700;
`;

const ProfileText = styled.div`
  font-family: "Segoe UI", Semibold;
  font-size: 18px;
  color: #ff3030;
  margin-bottom: 20px;
`;
const VisitorPhotoHeading = styled.div`
  font-family: "Segoe UI", Semibold;
  font-size: 25px;
  font-weight: 700;
  color: #2b3497;
  text-align: center;
  margin-bottom: 10px;
`;

const PhotoButton = styled.button`
  width: 160px;
  height: 35px;
  background-color: #343d9b;
  box-shadow: 0px 10px 10px #2b349733;
  border: 2px solid #343d9b;
  border-radius: 8px;
  opacity: 1;
  color: #ffffff;
  cursor: pointer;
  margin-bottom: 20px;
`;

const ActionButton = styled.button`
  width: 160px;
  height: 35px;
  background-color: transparent;
  border: 2px solid #343d9b;
  border-radius: 8px;
  box-shadow: 0px 10px 10px #2b349733;
  opacity: 1;
  cursor: pointer;
  margin-bottom: 20px;
  @media (max-width: 1420px) and (min-width: 1220px) {
    width: 125px;
  }
  @media (max-width: 1220px) and (min-width: 1020px) {
    width: 100px;
  }
`;
const CheckboxRowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  flex-direction: column;
`;
const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  color: red;
  font-family: "Segoe UI", Semibold;
  font-size: 14px;
`;
const CheckboxContainernew = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(100px, 1fr)
  ); /* Creates responsive grid */
  gap: 10px; /* Adds space between checkboxes */
  max-width: 500px; /* Adjust the width as needed */
`;

const PrivacyLink = styled.a`
  color: #2b3497;
  margin-left: 5px;
  text-decoration: none;
  cursor: pointer;
`;
const WebcamContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  overflow: hidden;
`;
const ButtonRow = styled.div`
  display: flex;
  gap: 10px; /* Adjust gap between buttons */
  margin-bottom: 20px; /* Optional: Adjust margin bottom */
`;

const Tabs = styled.div`
  display: flex;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
`;

const Tab = styled.button`
  background: none;
  border: none;
  font-family: "Segoe UI", Semibold;
  padding: 10px 20px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #000;
  &:hover {
    color: #2b3497;
  }
  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid #2B3497;
    color: #2B3497;
  `};
  ${({ disabled }) =>
    disabled &&
    `
  cursor:not-allowed;
  opacity: 0.5
  `}
`;
const Checkbox = styled.input`
  width: 18px; /* Increases the size of the checkbox */
  height: 20px;
  margin-right: 8px;
`;
const CheckboxLabel = styled.span`
  font-weight: 400;
  color: #000;
  font-size: 16px;
  margin-right: 8px; /* Adds space between the label and checkbox */
`;
const CheckboxLabelnew = styled.span`
  display: inline-flex;
  align-items: center; /* Ensures vertical alignment of the checkbox and text */
  gap: 8px; /* Adds space between the checkbox and text */
  font-size: 14px; /* Adjust based on your preferred font size */
  margin: 5px 0;
  font-weight: 400;
  color: #000;
`;

const TabContent = styled.div`
  display: ${({ active }) => (active ? "block" : "none")};
`;
const HeaderN = styled.h3`
  margin-top: 16px;
  color: ${(props) =>
    props.disabled ? "#a9a9a9" : "#000"}; /* Change color if disabled */
`;

const DropdownContainer = styled.div`
  margin-top: 16px;
`;

const DropdownLabel = styled.label`
  font-weight: 400;
  margin-right: 8px;
`;

const StyledDropdown = styled.select`
  padding: 10px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }

  option {
    padding: 8px;
  }
`;

const InputContainer = styled.div`
  margin-top: 16px;
  display: ${(props) => (props.show ? "flex" : "none")};
  gap: 14px;
`;

const SpinnerInput = styled.input`
  padding: 10px;
  width: 60px;
  text-align: center;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }
`;

const SpinnerInputLabel = styled.label`
  font-weight: 400;
`;

const RecurrenceInput = styled.input`
  padding: 10px;
  width: 80px;
  text-align: center;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  margin-left: 8px;

  &:focus {
    border-color: #293495;
    outline: none;
  }
`;

const AdditionalInputContainer = styled.div`
  margin-top: 16px;
  display: ${(props) => (props.show ? "flex" : "none")};
  flex-direction: column;
  align-items: flex-start;
`;
const AdditionalInputContainerN = styled.div`
  margin-top: 16px;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const SelectedValuesContainer = styled.div`
  margin-top: 10px;
  padding: 12px;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
`;

const SelectedHeader = styled.h4`
  margin-bottom: 11px;
  font-weight: bold;
  color: #293495;
`;

const ValueRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const SelectedValue = styled.div`
  font-weight: bold;
  color: #000;
`;

const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SwitchLabel = styled.label`
  font-weight: 400;
  font-size: 16px;
`;

const Switch = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const SwitchText = styled.span`
  font-weight: bold;
  margin-left: 10px;
  color: ${({ isOn }) =>
    isOn ? "#28a745" : "#6c757d"}; // Green for Yes, Gray for No
`;

const SwitchSlider = styled.div`
  width: 50px;
  height: 24px;
  background-color: ${({ isOn }) =>
    isOn ? "#28a745" : "#ccc"}; // Green for Yes, Gray for No
  border-radius: 34px;
  position: relative;
  transition: 0.4s;

  &:before {
    content: "";
    position: absolute;
    height: 20px;
    width: 20px;
    left: ${({ isOn }) =>
      isOn ? "26px" : "4px"}; // Moves the slider based on the toggle state
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
    transition: 0.4s;
  }
`;

const InputFieldContainer = styled.div`
  margin-top: 20px;
`;

const InputLabel = styled.label`
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
`;
const InputLabelN = styled.label`
  margin-bottom: 5px;
  display: block;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  font-family: "Arial", sans-serif;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
  box-sizing: border-box;
  resize: vertical;

  &:focus {
    border-color: #28a745;
  }
`;
const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const PopupContent = styled.div`
  background: white;
  width: 500px;
  max-height: 80%;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  text-align: left;
  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #293495; /* Custom scrollbar thumb color */
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ff3030; /* Hover color */
  }

  /* Firefox scrollbar */
  scrollbar-color: #293495 #f1f1f1;
  scrollbar-width: thin;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center; /* Center the button horizontally */
  margin-top: 20px;
`;

const CloseButton = styled.button`
  background-color: #293495;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #ff3030;
  }
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(#ffffff, #f5f5f5, #ffffff);
  box-shadow: 0px 0px 1px #0000004a;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  z-index: 1000;
  width: 500px;
`;

const PopupButton = styled.button`
  background-color: #2b3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2b349754;
  cursor: pointer;
  margin-left: 10px;
  &.no-button {
    background-color: red; /* Change color to red for No button */
  }
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2b3497;
  margin-bottom: 20px;
`;

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
`;

const Chip = styled.div`
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 5px 10px;
  margin: 2px;
  display: flex;
  align-items: center;
  font-size: 14px;
`;
const FormRow = styled.div`
  display: flex;
  gap: 20px; /* Adjust spacing between inputs */
  justify-content: space-between;
  width: 100%;
`;
const RemoveChipButton = styled.span`
  color: #ff0000;
  font-weight: bold;
  margin-left: 5px;
  cursor: pointer;
`;

const InputField = styled.input`
  border: none;
  outline: none;
  flex: 1;
  font-size: 14px;
  margin-left: 5px;
  padding: 5px;
`;

const SuggestionBox = styled.ul`
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 5px 0 0;
  padding: 0;
  list-style: none;
  background: white;
  max-height: 150px;
  overflow-y: auto;
`;

const SuggestionItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;
//css file acknowlaged
const AckItem = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 12px;
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #f0f4ff;
  }

  input {
    margin-top: 3px;
    cursor: pointer;
  }
`;

const AckText = styled.span`
  font-size: 14px;
  color: #333;
  line-height: 1.4;

  a {
    color: #293495;
    font-weight: 500;
    text-decoration: underline;
  }
`;

const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  overflow-x: auto; /* makes it scrollable horizontally */
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(
    to right,
    #e6e6e6,
    #f2f2f2,
    #f5f5f5,
    #f3f3f3,
    #e9e9e9
  );
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 9px 10px;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
  font-size: 13px;
`;

const PdfModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

const PdfModalContent = styled.div`
  background: #fff;
  padding: 20px;
  width: 80%;
  max-width: 900px;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #0000001a;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const CloseButtonIcon = styled.button`
  position: absolute;
  top: 4px;
  right: 15px;
  border: none;
  background: transparent;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  color: #293495;
`;

const PdfFrame = styled.iframe`
  width: 100%;
  height: 80vh;
  border: none;
  margin-top: 10px;
`;

const AgreeButton = styled.button`
  margin-top: 15px;
  align-self: flex-end;
  padding: 10px 18px;
  background: #293495;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;

  &:hover {
    background: #1f276f;
  }
`;

const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const CustomFileButton = styled.button`
  background-color: #293495;
  color: #ffffff;
  padding: 8px 16px;
  font-size: 14px;
  font-family: "Segoe UI", Semibold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #1f2875;
  }
`;

const FileNameInput = styled.input`
  flex: 1;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  color: #000;

  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

const AppoinmentLeaderFormPage = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [selectedGate, setSelectedGate] = useState("");
  const [activeTab, setActiveTab] = useState("details"); // State for tab management
  const [selectedVisitorType, setSelectedVisitorType] = useState("");
  const [selectedIdProofType, setSelectedIdProofType] = useState("");

  const [visitorTypes, setVisitorTypes] = useState([]);
  const [idProofTypes, setIdProofTypes] = useState([]);

  const [meetingvenues, setMeetingvenues] = useState([]);
  const [gates, setGates] = useState([]);
  const [buildings, setBuildings] = useState([]);

  const [isChecked, setIsChecked] = useState(false);
  const [recurrencePattern, setRecurrencePattern] = useState("");
  const [selectedrecurrencePattern, setSelectedrecurrencePattern] =
    useState("");
  const [recurrencePatternAPI, setRecurrencePatternAPI] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedWeekday, setSelectedWeekday] = useState("");
  const [selectedWeekdayAPI, setSelectedWeekdayAPI] = useState("");

  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedMonthAPI, setSelectedMonthAPI] = useState("");

  const [isAllDayChecked, setIsAllDayChecked] = useState(false);
  const [recurEvery, setRecurEvery] = useState(1);

  const [isAssistanceRequired, setIsAssistanceRequired] = useState(false);
  const [isServiceProviderAccess, setIsServiceProviderAccess] = useState(false);
  const [isWiFiRequired, setIsWiFiRequired] = useState(false);
  const [isEscortRequired, setIsEscortRequired] = useState(false);
  const [isadditionalNotify, setIsAdditionalNotify] = useState(false);

  const [additionalMessage, setAdditionalMessage] = useState("");
  const [checkInInstructions, setCheckInInstructions] = useState("");

  const toggleAssistanceRequired = () =>
    setIsAssistanceRequired(!isAssistanceRequired);
  const toggleServiceProviderAccess = () =>
    setIsServiceProviderAccess(!isServiceProviderAccess);
  const toggleWiFiRequired = () => setIsWiFiRequired(!isWiFiRequired);
  const toggleEscortRequired = () => setIsEscortRequired(!isEscortRequired);
  const toggleadditionalNotifyRequired = () =>
    setIsAdditionalNotify(!isadditionalNotify);

  const handleAdditionalMessageChange = (e) =>
    setAdditionalMessage(e.target.value);
  const handleCheckInInstructionsChange = (e) =>
    setCheckInInstructions(e.target.value);
  const [nationalityList, setNationalityList] = useState([]);
  const location = useLocation(); // Initialize useNavigate hook

  const { decryptedAppId, hostName } = location.state || {};
  const [appointmentData, setAppointmentData] = useState("");

  const [loading, setLoading] = useState(false); // Global loading state
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const sigCanvasRef = useRef(null);
  const [ndaSignature, setNDASignature] = useState("");

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);
  };
  const handleDropdownChange = (event) => {
    console.log("event.target", event.target);
    const selectedText = event.target.options[event.target.selectedIndex].text;
    console.log("selectedText", selectedText);
    // This gets the text of the selected option

    setRecurrencePattern(event.target.value);
    if (event.target.value == "1") {
      setRecurrencePatternAPI(1);
    }
    if (event.target.value == "2") {
      setRecurrencePatternAPI(2);
    }
    if (event.target.value == "3") {
      setRecurrencePatternAPI(3);
    }
  };
  const handleDayChange = (event) => {
    setSelectedDay(event.target.value);
  };
  const handleWeekdayCheckboxChange = (weekday) => {
    setSelectedWeekday(
      (prev) =>
        prev.includes(weekday)
          ? prev.filter((day) => day !== weekday) // Remove if already selected
          : [...prev, weekday], // Add if not selected
    );
  };
  const handleMonthCheckboxChange = (month) => {
    setSelectedMonth(
      (prev) =>
        prev.includes(month)
          ? prev.filter((m) => m !== month) // Remove if already selected
          : [...prev, month], // Add if not selected
    );
  };
  const handleAllDayCheckboxChange = () => {
    setIsAllDayChecked((prev) => !prev);
  };

  const handleRecurEveryChange = (event) => {
    setRecurEvery(event.target.value);
  };

  const getRecurrencePatternAPIValue = () => {
    switch (recurrencePattern) {
      case "1":
        return 1;
      case "2":
        return 2;
      case "3":
        return 3;
      default:
        return null; // Handle default case as needed
    }
  };

  // Generate an array for days 1 to 31
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const [employeeData, setEmployeeData] = useState([]); // To store the employee data
  const [employeeId, setEmployeeId] = useState("");
  const [managerMail, setManagerMail] = useState("");
  const [empName, setEmpName] = useState("");
  const [empNameID, setEmpNameID] = useState("");

  useEffect(() => {
    const empIdLocal = localStorage.getItem("OTPEMPID"); // ✅ read once synchronously
    setEmpNameID(empIdLocal);
    if (decryptedAppId) {
      console.log("Decrypted appId:", decryptedAppId);
      // Fetch appointment data
      const fetchAppointmentData = async (id) => {
        try {
          const response = await axiosInstance.get(
            `/GroupAppointment/GetGroupLeaderByAppid?id=${id}`,
          );
          if (response.status === 200) {
            console.log("Appointment data fetched:", response.data);
            setAppointmentData(response.data);
            const empData = response.data;
            console.log("empData", empData);

            if (empData[0].createdBy) {
              fetchManagerMail(empData[0].createdBy);
              setEmpNameID(empData[0].createdBy);
              localStorage.setItem("empIdOtp");
            }
          } else {
            console.error("Failed to fetch appointment data");
          }
        } catch (error) {
          console.error("Error fetching appointment data:", error);
        }
      };
      const getVisitorTypes = async () => {
        const EmpId = localStorage.getItem("empIdOtp");
        try {
          const types = await axiosInstance.get(
            `/VisitorType/GetVisitorTypeDetailsByEmpId/${empIdLocal}`,
          );
          setVisitorTypes(types.data);
        } catch (error) {
          console.error("Error fetching visitor types:", error);
        }
      };
      getVisitorTypes();

      fetchAppointmentData(decryptedAppId);
      const getIdProofTypes = async () => {
        try {
          const types = await axiosInstance.get("/idproof");
          setIdProofTypes(types.data);
        } catch (error) {
          console.error("Error fetching visitor types:", error);
        }
      };
      getIdProofTypes();
    }
    const getMeetingvenues = async () => {
      try {
        const EmpId = localStorage.getItem("empIdOtp");

        const venues = await axiosInstance.get(
          `/Location/GetLocationByEmpId?empId=${empIdLocal}`,
        );
        setMeetingvenues(venues.data);
        const defaultVenue = venues?.data.find(
          (venue) => venue.defaultLocation,
        );
        console.log("defaultVenue", defaultVenue);

        if (defaultVenue) {
          setFormData((prev) => ({
            ...prev,
            meetingVenue: defaultVenue.locationName,
          }));

          const menuNameResponse = await axiosInstance.get(
            `/Location/GetGatesByLocationID?locationID=${defaultVenue?.id}`,
          );
          setGates(menuNameResponse.data);
          console.log("gates", menuNameResponse.data);

          const defaultVenueGate = gates.find((venue) => venue.defaultGate);
          console.log("defaultVenueGate", defaultVenueGate);

          if (defaultVenueGate) {
            // setFormData(prev => ({
            //   ...prev,
            //   gate: defaultVenueGate.id
            // }));
            // const gateID = defaultVenueGate.id; // Convert to integer if gate.id is a number

            // const selectedGateObject = gates.find(gate => gate.id === gateID);

            // setSelectedGate(selectedGateObject.id);
            // console.log("set",selectedGate);
            const gateID = parseInt(defaultVenueGate.id, 10); // Convert to integer if gate.id is a number
            const selectedGateObject = menuNameResponse.data.find(
              (gate) => gate.id === gateID,
            );
            console.log("selectedGateObject", selectedGateObject);

            setSelectedGate(selectedGateObject);
            if (selectedGate) {
              setFormData((prevFormData) => ({
                ...prevFormData,
                gate: selectedGate.name, // Use the gate name in the form data
              }));
            }

            // const buildings = await axiosInstance.get(
            //   `/Location/GetBuidingsByGateID?gateID=${defaultVenueGate.id}`,
            // );
            const buildingsResponse = await axiosInstance.get(
                `/Location/GetBuildingAndGateByLocationId/${defaultVenue.id}`,
            );
            const fetchedBuildings = buildingsResponse.data?.data?.buildings || [];
            setBuildings(fetchedBuildings);
          }
        }
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    getMeetingvenues();
    const fetchAppointmentDataeemp = async () => {
      try {
        const responseeEMP = await axiosInstance.get("/Employee/");
        console.log("response", responseeEMP);
        console.log("Employee Data:", responseeEMP.data);
        setEmployeeData(responseeEMP.data);
      } catch (error) {
        console.error("Error fetching appointment data:", error);
      }
    };
    const getNationality = async () => {
      try {
        const nation = await axiosInstance.get("/Nationality");
        setNationalityList(nation.data);
        const defaultNation = nation.find((n) => n.isDefault === true);
        if (defaultNation) {
          setFormData((prevData) => ({
            ...prevData,
            nationality: defaultNation.name,
          }));
          setDefaultCode(defaultNation.nationalityCode);
        }
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    fetchAppointmentDataeemp();
    getNationality();
  }, [decryptedAppId]);

  const [employeeMail, setEmployeeMail] = useState("");
  const [entityID, setEntityID] = useState("");
  //console.log("entityId", entityID)

  const fetchManagerMail = async (id) => {
    try {
      const response = await axiosInstance.get(`/Employee/${id}`);
      console.log("response", response);
      setEmployeeMail(response.data.employeeMailId);
      setEmpName(response.data.employeeName);
      if (response?.data?.entityID) {
        setEntityID(response?.data?.entityID);
      } else {
        toast.error("Entity ID is missing!");
      }

      // Assuming API returns empMail property

      setManagerMail(response.data.managerMailID); // Assuming API returns empMail property
      console.log("managerMailID", response.data.managerMailID);
      const managerMailId = response.data.managerMailID;

      // if (managerMailId) {
      //     fetchManagerName(managerMailId);
      // }
    } catch (error) {
      console.error("Error fetching fetchManagerMail:", error);
    }
  };
  const [fieldData, setFieldData] = useState("");

  const [inputValue, setInputValue] = useState("");
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  const handleInputChangeN = (e) => {
    const value = e.target.value;
    setInputValue(value);

    // Filter suggestions only if input is not empty
    if (value) {
      setFilteredSuggestions(
        employeeData.filter(
          (emp) =>
            emp.employeeMailId &&
            emp.employeeMailId.toLowerCase().includes(value.toLowerCase()),
        ),
      );
    } else {
      setFilteredSuggestions([]);
    }
  };

  const handleSuggestionClick = (email) => {
    if (!selectedEmails.includes(email)) {
      setSelectedEmails((prev) => [...prev, email]);
    }
    setInputValue("");
    setFilteredSuggestions([]);
  };

  const handleChipRemove = (email) => {
    setSelectedEmails((prev) => prev.filter((e) => e !== email));
  };
  useEffect(() => {
    // Log the selected emails to the console whenever they update
    console.log("Selected Emails:", selectedEmails);
  }, [selectedEmails]);

  const handleKeyDown = (e) => {
    if (
      e.key === "Enter" &&
      inputValue &&
      !selectedEmails.includes(inputValue)
    ) {
      setSelectedEmails((prev) => [...prev, inputValue]);
      setInputValue("");
      setFilteredSuggestions([]);
    }
  };
  useEffect(() => {
    if (selectedGate) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        gate: selectedGate.name, // Use the gate name in the form data
      }));
    }
  }, [selectedGate]);
  const [defaultCode, setDefaultCode] = useState({});
  const handleDateChange = (date, field) => {
    console.log("Selected date:", date, "Field:", field); // Log the selected date

    if (
      date &&
      Object.prototype.toString.call(date) === "[object Date]" &&
      !isNaN(date)
    ) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [field]: date, // Ensure the selected date is valid
      }));

      // Clear any form errors related to this field
      if (formErrors[field]) {
        setFormErrors((prevFormErrors) => ({
          ...prevFormErrors,
          [field]: false,
        }));
      }
    } else {
      console.error("Invalid date value:", date);
    }
  };

  const currentDateTime = new Date(); // Current date and time

  // Function to filter out times earlier than the current time
  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };

  // Function to highlight the current time
  const highlightTime = (time) => {
    const now = new Date();
    const timeToHighlight = now.getHours() * 60 + now.getMinutes();
    const selectedTime = time.getHours() * 60 + time.getMinutes();

    // Highlight the time close to the current system time
    return selectedTime === timeToHighlight ? "highlight-time" : "";
  };

  const validateMeetingTimes = () => {
    if (
      formData.meetingFrom &&
      formData.meetingTo &&
      formData.meetingFrom >= formData.meetingTo
    ) {
      toast.error("Meeting end time must be greater than the start time");
      setFormErrors((prevFormErrors) => ({
        ...prevFormErrors,
        meetingTo: true,
      }));
      return false;
    }
    return true;
  };
  const adjustForTimezoneOffset = (date) => {
    if (!date) return null;
    const timezoneOffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
    const localISOTime = new Date(date.getTime() - timezoneOffset)
      .toISOString()
      .slice(0, -1);
    return localISOTime;
  };

  const handleGateChange = async (event) => {
    const gateID = parseInt(event.target.value, 10); // Convert to integer if gate.id is a number
    const selectedGateObject = gates.find((gate) => gate.id === gateID);

    setSelectedGate(selectedGateObject); // Store the entire gate object

    // try {
    //   const buildings = await axiosInstance.get(
    //     `/Location/GetBuidingsByGateID?gateID=${gateID}`,
    //   );
    //   setBuildings(buildings);
    // } catch (error) {
    //   console.error("Error fetching buildings:", error);
    // }
  };

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    // groupLeaderName: '',
    visitorEmail: "",
    gender: "",
    nationality: "",
    visitorMobile: "",
    company: "",
    meetingFrom: null,
    meetingTo: null,
    selectedVisitorTypeId: selectedVisitorType,
    selectedIdProofTypeId: selectedIdProofType,
    idProofNo: "",
    gate: "",
    building: "",
    visitorPhoto: "",
    purpose: "",
    vehicleno: "",
    nationalityCode: "",
  });

  console.log("form data", formData);

  const [formErrors, setFormErrors] = useState({
    firstName: false,
    middleName: false,
    lastName: false,
    gender: false,
    nationality: false,

    // groupLeaderName: false,
    visitorEmail: false,
    visitorMobile: false,
    meetingVenue: false,
    company: false,
    meetingFrom: false,
    meetingTo: false,
    selectedVisitorTypeId: false,
    selectedIdProofTypeId: false,
    gate: false,
    building: false,
    purpose: false,
  });

  const handleResetAcknowledgement = () => {
    setAckChecklist((prev) =>
      Object.fromEntries(Object.keys(prev).map((key) => [key, false])),
    );
  };

  const handleReset = () => {
    setIsCheckedP(false);
    setIsCheckedC(false);
    setSelectedGate();
    setFormData({
      // firstName: '',
      // middleName: '',
      // lastName: '',
      // gender: '',
      // nationality: '',
      // // groupLeaderName: '',
      // visitorEmail: '',
      // visitorMobile: '',
      // visitorPhoto: '',
      vehicleno: "",
      company: "",
      // meetingFrom: null,
      // meetingTo: null,
      // selectedVisitorTypeId: '',
      // selectedIdProofTypeId: '',
      // idProofNo: '',
      // gate: '',
      // building: '',
      visitorPhoto: "",
      // purpose: '',
    });
    setProfileImage("");
    // setFormErrors({
    //   firstName: fieldData.visitorNameField,
    //   lastName: fieldData.visitorNameField,
    //   gender: fieldData.genderField,
    //   nationality: fieldData.nationalityField,

    //   // groupLeaderName: false,
    //   visitorEmail: fieldData.visitorEmailField,
    //   visitorMobile: fieldData.visitorMobileField,
    //   meetingVenue: fieldData.locationField,
    //   // company: fieldData.visitorCompanyField,
    //   meetingFrom: fieldData.meetingOnField,
    //   meetingTo: fieldData.meetingToField,
    //   selectedVisitorTypeId: false,
    //   selectedIdProofTypeId: fieldData.idProofTypeField,
    //   gate: fieldData.gateField,
    //   building: fieldData.areaField,
    //   purpose: fieldData.purpose,

    // });
    setMeetingvenues([]);

    const getMeetingvenues = async () => {
      try {
        const venues = await axiosInstance.get(
          `/Location/GetLocationByEmpId?empId=${empNameID}`,
        );
        setMeetingvenues(venues);
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    getMeetingvenues();

    setIsChecked(false);
    setRecurrencePattern(""); // Set to default value (1 for Daily)
    setSelectedDay("");
    setSelectedWeekday("");
    setSelectedMonth("");
    setRecurEvery("");
    setIsAllDayChecked(false);
    setIsAssistanceRequired(false);
    setIsServiceProviderAccess(false);
    setIsWiFiRequired(false);
    setIsEscortRequired(false);
    setAdditionalMessage("");
    setCheckInInstructions("");
    setIsAdditionalNotify("");

    console.log("Form reset");
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false,
      });
    }
  };

  const handleChangeLo = async (e) => {
    const { name, value } = e.target;
    console.log(name);
    console.log(value);

    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false,
      });
    }
    const selectedLocation = meetingvenues.find(
      (item) => item.locationName === value,
    );

    console.log("Selected Location Object:", selectedLocation);

    if (selectedLocation) {
      try {
        const menuNameResponse = await axiosInstance.get(
          `/Location/GetBuildingsByLocation?locationID=${selectedLocation.id}`,
        );
        console.log("menuNameResponse", menuNameResponse);
        setGates(menuNameResponse.data);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.error("No gates found for the provided location.");
        } else {
          toast.error("An error occurred while fetching gates.");
        }
      }
    }
  };
  const handleChangeNew = (e) => {
    const { name, value } = e.target;
    console.log("visitor type", e.target.value);
    const selectedText = e.target.options[e.target.selectedIndex].text; // Get the selected text
    console.log("Selected text:", selectedText);
    const selectedType = visitorTypes.find(
      (type) => type.id === parseInt(value),
    );
    console.log("Selected Visitor Type Object:", selectedType);

    if (selectedText == "Service Engineer") {
      console.log("show instruction");
      setCheckInInstructions(`Use Hard Hat and Eye Protection in the Working Zone.Use Hand protection Gloves, Safety Shoe and Belts while working in the site.Use well Insulated wiring, proper plugs while using any electrical Machine.Use proper Scaffolding while working at Heights.

      `);
    } else if (selectedType) {
      setCheckInInstructions(selectedType.checkinInstruction || "");
    }

    setFormData({
      ...formData,
      [name]: value,
    });
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false,
      });
    }
  };
  const [existingData, setExistingData] = useState("");
  function getCurrentDateTime() {
    const date = new Date();

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleNext = async () => {
    let valid = true;
    const errors = {};

    if (!entityID) {
      toast.error("Entity ID is missing");
      return;
    }
    // if (formData.groupLeaderName === '') {
    //   errors.groupLeaderName = true;
    //   valid = false;
    // }
    if (fieldData?.visitorNameField && formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (fieldData?.visitorNameField && formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (fieldData?.visitorEmailField && formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (fieldData?.genderField && formData.gender === "") {
      errors.gender = true;
      valid = false;
    }
    if (fieldData?.nationalityField && formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (fieldData?.visitorMobileField && formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    // if (fieldData.visitorCompanyField && formData.company === '') {
    //   errors.company = true;
    //   valid = false;
    // }
    if (formData?.selectedVisitorTypeId === "") {
      errors.selectedVisitorTypeId = true;
      valid = false;
    }
    if (fieldData?.purpose && formData.purpose === "") {
      errors.purpose = true;
      valid = false;
    }
    if (formData?.company === "") {
      errors.company = true;
      valid = false;
    }
    if (fieldData?.meetingOnField && formData.meetingFrom === null) {
      errors.meetingFrom = true;
      valid = false;
    }
    if (fieldData?.meetingToField && formData.meetingTo === null) {
      errors.meetingTo = true;
      valid = false;
    }
    if (fieldData?.locationField && formData.meetingVenue === "") {
      errors.meetingVenue = true;
      valid = false;
    }
    if (fieldData?.gateField && formData.gate === "") {
      errors.gate = true;
      valid = false;
    }
    if (fieldData?.areaField && formData.building === "") {
      errors.building = true;
      valid = false;
    }
    if (fieldData?.idProofTypeField && formData.selectedIdProofTypeId === "") {
      errors.selectedIdProofTypeId = true;
      valid = false;
    }
    if (fieldData?.idProofNumberField && formData.idProofNo === "") {
      errors.idProofNo = true;
      valid = false;
    }

    if (formData.visitorEmail !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.visitorEmail)) {
        errors.visitorEmail = true;
        valid = false;
      }
    }

    if (fieldData?.visitorMobileField && formData.visitorMobile === null) {
      errors.visitorMobile = true;
      valid = false;
    }
    if (isadditionalNotify) {
      if (selectedEmails == "") {
        toast.error("please fill the message to notify field");
      }
    }
    if (!validateMeetingTimes()) {
      valid = false;
    }
    if (!valid) {
      setFormErrors(errors);
      toast.error("Please fill all the mandatory  fields.");
      setActiveTab("details");
      setLoading(false);
      return;
    }

    setFormErrors(errors);
    const toLocalISOString = (date) => {
      const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
      const localDate = new Date(date - tzOffset); // Apply the offset to get local time
      return localDate.toISOString().slice(0, -1); // Remove the 'Z' from the ISO string
    };
    if (formData.visitorPhoto == "") {
      toast.error("photo is not captured, Please upload the photo ");
      setLoading(false);
      setActiveTab("details");
      return;
    }
    if (isCheckedP && isCheckedC) {
      setDetailsValid(true);
      setActiveTab("acknowledge");
    } else {
      setLoading(false); // Stop loader in all cases
      toast.error("Please verify the privacy and covid fitness");
    }
  };

  const messages = {
    training: "Please agree to the Training Video acknowledgment.",
    safetyVideo: "Please agree to the Safety Video acknowledgment.",
    safetyDoc: "Please agree to the Safety Document acknowledgment.",
    ndaDoc: "Please agree to the NDA Document.",
  };

  const handleSubmit = async (event) => {
    setLoading(true); // Start loader

    let valid = true;
    const errors = {};
    if (!entityID) {
      setLoading(false);
      toast.error("Entity ID is missing");
      return;
    }

    // if (formData.groupLeaderName === '') {
    //   errors.groupLeaderName = true;
    //   valid = false;
    // }
    if (fieldData?.visitorNameField && formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (fieldData?.visitorNameField && formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (fieldData?.visitorEmailField && formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (fieldData?.genderField && formData.gender === "") {
      errors.gender = true;
      valid = false;
    }
    if (fieldData?.nationalityField && formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (fieldData?.visitorMobileField && formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    // if (fieldData.visitorCompanyField && formData.company === '') {
    //   errors.company = true;
    //   valid = false;
    // }
    if (formData?.selectedVisitorTypeId === "") {
      errors.selectedVisitorTypeId = true;
      valid = false;
    }
    if (fieldData?.purpose && formData.purpose === "") {
      errors.purpose = true;
      valid = false;
    }
    if (formData?.company === "") {
      errors.company = true;
      valid = false;
    }
    if (fieldData?.meetingOnField && formData.meetingFrom === null) {
      errors.meetingFrom = true;
      valid = false;
    }
    if (fieldData?.meetingToField && formData.meetingTo === null) {
      errors.meetingTo = true;
      valid = false;
    }
    if (fieldData?.locationField && formData.meetingVenue === "") {
      errors.meetingVenue = true;
      valid = false;
    }
    if (fieldData?.gateField && formData.gate === "") {
      errors.gate = true;
      valid = false;
    }
    if (fieldData?.areaField && formData.building === "") {
      errors.building = true;
      valid = false;
    }
    if (fieldData?.idProofTypeField && formData.selectedIdProofTypeId === "") {
      errors.selectedIdProofTypeId = true;
      valid = false;
    }
    if (fieldData?.idProofNumberField && formData.idProofNo === "") {
      errors.idProofNo = true;
      valid = false;
    }

    if (formData.visitorEmail !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.visitorEmail)) {
        errors.visitorEmail = true;
        valid = false;
      }
    }

    if (fieldData?.visitorMobileField && formData.visitorMobile === null) {
      errors.visitorMobile = true;
      valid = false;
    }
    if (isadditionalNotify) {
      if (selectedEmails == "") {
        toast.error("please fill the message to notify field");
      }
    }
    if (!validateMeetingTimes()) {
      valid = false;
    }
    if (!valid) {
      setFormErrors(errors);
      toast.error("Please fill all the mandatory  fields.");
      setActiveTab("details");
      setLoading(false);
      return;
    }
    for (const key in ackChecklist) {
      console.log("key value", key);
      if (ackChecklist[key] === false) {
        setActiveTab("acknowledge");
        toast.error(messages[key]);
        setLoading(false);
        return;
      }
    }

    setFormErrors(errors);
    const toLocalISOString = (date) => {
      const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
      const localDate = new Date(date - tzOffset); // Apply the offset to get local time
      return localDate.toISOString().slice(0, -1); // Remove the 'Z' from the ISO string
    };
    if (formData.visitorPhoto == "") {
      toast.error("photo is not captured, Please upload the photo ");
      setLoading(false);
      return;
    }

    const formattedData = {
      ...formData,
      meetingFrom: toLocalISOString(new Date(formData.meetingFrom)),
      meetingTo: toLocalISOString(new Date(formData.meetingTo)),
    };
    sessionStorage.setItem("savedFormData", JSON.stringify(formData));

    const gateRes = await axiosInstance.get(
      `Location/GetGateByName?GateName=${formData.meetingVenue}`,
    );
    console.log("gateRes", gateRes.data);

    console.log("Form data:", formData);
    console.log("Form data:", formattedData);
    if (isCheckedP && isCheckedC) {
      const requestData = {
        id: appointmentData[0].id,
        groupLeaderName: appointmentData[0].groupLeaderName,
        visitorMobile: formData.visitorMobile,
        visitorCompany: formData.company,
        visitorEmail: formData.visitorEmail,
        appointmentStatus: "Scheduled",
        createdBy: appointmentData[0].createdBy,
        createdDate: appointmentData[0].createdDate,
        modifiedBy: appointmentData[0].createdBy,
        modifiedDate: appointmentData[0].modifiedDate,
        appointmentDate: appointmentData[0].appointmentDate,
        meetingVenue: formData.meetingVenue,
        locationId: 0,
        idProofType: formData.selectedIdProofTypeId || 0,
        idProofNo: formData.idProofNo,
        validTill: formData.meetingTo,
        selectedVisitorTypeId: formData.selectedVisitorTypeId,
        txtManagersID: "",
        txtFloor: " ",
        txtMeetingRoom: " ",
        photo: formData.visitorPhoto,
        txtCostCenter: " ",
        checkInTime: null,
        checkOutTime: null,
        gate: formData.gate,
        gateId: 0,
        buildingId: 0,
        building: formData.building,
        purpose: formData.purpose,
        nationalityId: 0,
        statusCode: 0,
        message: null,
        assitanceRequired: appointmentData[0].assitanceRequired,
        serviceProviderAccess: appointmentData[0].serviceProviderAccess,
        wifiRequired: appointmentData[0].wifiRequired,
        escort: appointmentData[0].escort,
        additionalNotification: appointmentData[0].additionalNotification,
        messageToVisitor: appointmentData[0].messageToVisitor,
        checkinInstruction: appointmentData[0].checkinInstruction,
        allDay: appointmentData[0].allDay,
        repeatVisit: appointmentData[0].repeatVisit || false,
        recurrancePattern: appointmentData[0].recurrancePattern || 0,
        recurEvery: appointmentData[0].recurEvery || 0,
        selectedRecurrence: appointmentData[0].selectedRecurrence || "",
        country: "India",
        reason: null,
        notifyTo: " ",
        idProofName: " ",
        firstName: formData.firstName,
        middleName: formData.middleName,
        lastName: formData.lastName,
        nationality: formData.nationality,
        gender: formData.gender,
        isGroupLeader: true,
        blockCalendar: true,
        vehicleNo: formData.vehicleno || null,
        NDASignature: ndaSignature,
      };

      const response = await axiosInstance.put(
        "/GroupAppointment/GroupAppointmentUpdated",
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        setLoading(false); // Stop loader in all cases
        toast.success("Successfully Updated!");
        setIsSubmitted(true);

        console.log("Appointment updated successfully:", response.data);
        // Call sendEmail with the updated appointment data
        // await sendEmail(appointmentData);
        // const formattedData = formData
        const formDataAdditional = appointmentData[0];

        navigate("/group-appoinment-details", {
          state: { formattedData, formDataAdditional },
        });
        // Store the appointment data from the response
        // setMailData(response.data);
      } else {
        setLoading(false); // Stop loader in all cases
        console.error("Failed to update appointment");
      }
    } else {
      setLoading(false); // Stop loader in all cases
      toast.error("Please verify the privacy and covid fitness");
    }

    // const formattedEmails = selectedEmails.join(', ');;
    // console.log("Submitting Emails:", formattedEmails);

    // const formDataAdditional = {
    //   repeatVisit: isChecked,
    //   recurrencePattern: recurrencePatternAPI,
    //   selectedRecurrence: String(newSelectedRecurrencePattern),
    //   selectedDay: selectedDay,
    //   selectedWeekday: selectedWeekdayAPI,
    //   selectedMonth: selectedMonthAPI,
    //   recurEvery: recurEvery,
    //   isAllDay: isAllDayChecked,
    //   assistanceRequired: isAssistanceRequired,
    //   serviceProviderAccess: isServiceProviderAccess,
    //   wifiRequired: isWiFiRequired,
    //   escortRequired: isEscortRequired,
    //   additionalNotification: isadditionalNotify,
    //   additionalMessage: additionalMessage,
    //   checkInInstructions: checkInInstructions,
    //   notifyTo: formattedEmails,
    // };

    // Log the object to the console
    // console.log('Form Data formDataAdditional:', formDataAdditional);

    // if (!valid) {
    //   setFormErrors(errors);
    //   toast.error("please fill all fields");
    //   console.log('Form has errors:', errors);
    // } else {
    //   console.log('Form data:', formData);
    //   const blackListCheck = await axiosInstance.get(`/BlackList/${formattedMobileNumber}`)
    //   if (blackListCheck.data) {
    //     toast.error("Person with this mobile number is blacklisted");
    //     // Show the popup when the icon is clicked
    //   }
    //   else if (isCheckedP && isCheckedC) {
    //     navigate('/layout/group-appoinment-details', { state: { formattedData, formDataAdditional } });

    //   }
    //   else {
    //     toast.error('Please verify the privacy and covid fitness')

    //   }

    // }
    // setIsChecked(false);
    // setRecurrencePattern(''); // Set to default value (1 for Daily)
    // setSelectedDay('');
    // setSelectedWeekday('');
    // setSelectedMonth('');
    // setRecurEvery('');
    // setIsAllDayChecked(false);
    // setIsAssistanceRequired(false);
    // setIsServiceProviderAccess(false);
    // setIsWiFiRequired(false);
    // setIsEscortRequired(false);
    // setAdditionalMessage('');
    // setCheckInInstructions('');
    // setIsAdditionalNotify('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false,
    }));
  };

  const webcamRef = useRef(null);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [buttonLabel, setButtonLabel] = useState("Take photo");
  const [profileImage, setProfileImage] = useState(null);

  const resizeAndCompress = async (canvas) => {
    const targetWidth = 320; // Reduce width
    const targetHeight = 240; // Reduce height

    const resizedCanvas = document.createElement("canvas");
    resizedCanvas.width = targetWidth;
    resizedCanvas.height = targetHeight;

    const resizedCtx = resizedCanvas.getContext("2d");
    resizedCtx.drawImage(canvas, 0, 0, targetWidth, targetHeight);

    // Lower quality to reduce base64 sizex

    return resizedCanvas.toDataURL("image/jpeg", 0.3); // JPEG format, 30% quality
  };

  const processImageWithSegmentation = async (image) => {
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0, image.width, image.height);

    const segmentation = new SelfieSegmentation({
      locateFile: (file) =>
        `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
    });

    segmentation.setOptions({ modelSelection: 1 });
    await segmentation.initialize();

    const results = await new Promise((resolve) => {
      segmentation.onResults(resolve);
      segmentation.send({ image });
    });

    const outputCanvas = document.createElement("canvas");
    outputCanvas.width = image.width;
    outputCanvas.height = image.height;
    const outputCtx = outputCanvas.getContext("2d");

    // Draw the original image
    outputCtx.drawImage(image, 0, 0, image.width, image.height);

    // Apply segmentation mask to retain only face
    outputCtx.globalCompositeOperation = "destination-in";
    outputCtx.drawImage(results.segmentationMask, 0, 0);

    // Fill background with white instead of transparent
    outputCtx.globalCompositeOperation = "destination-over";
    outputCtx.fillStyle = "#fff"; // WHITE background
    outputCtx.fillRect(0, 0, image.width, image.height);

    // Resize and compress
    return resizeAndCompress(outputCanvas);
  };

  const handleCapture = async () => {
    if (!isCameraOn) {
      setIsCameraOn(true);
      setButtonLabel("Capture");
    } else {
      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) return;

      const img = new Image();
      img.src = imageSrc;

      img.onload = async () => {
        const faceDetection = new FaceDetection({
          locateFile: (file) =>
            `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`,
        });

        faceDetection.setOptions({
          model: "short", // fast + accurate model
          minDetectionConfidence: 0.5,
        });

        await faceDetection.initialize();

        // Run face detection
        const detectionResults = await new Promise((resolve) => {
          faceDetection.onResults(resolve);
          faceDetection.send({ image: img });
        });

        // Check if face is detected
        if (
          !detectionResults.detections ||
          detectionResults.detections.length === 0
        ) {
          toast.error("Human face not detected");
          return;
        }

        const base64Image = await processImageWithSegmentation(img);
        setProfileImage(base64Image);
        setFormData((prev) => ({
          ...prev,
          visitorPhoto: base64Image.split(",")[1],
        }));
      };

      setIsCameraOn(false);
      setButtonLabel("Take photo");
    }
  };

  const fileInputRef = useRef(null); // Add this line at the top

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || (file.type !== "image/png" && file.type !== "image/jpeg")) {
      toast.error("Please upload a PNG or JPEG image");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = async () => {
      const img = new Image();
      img.src = reader.result;

      img.onload = async () => {
        const base64Image = await processImageWithSegmentation(img);
        setProfileImage(base64Image);

        setFormData((prev) => ({
          ...prev,
          visitorPhoto: base64Image.split(",")[1],
        }));

        setIsCameraOn(false); // ✅ turn off camera view if it's still on
        setButtonLabel("Take photo");
      };
    };

    reader.readAsDataURL(file);

    // ✅ Reset the input value so uploading the same image again still triggers onChange
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // const handleCapture = async () => {
  //   if (!isCameraOn) {
  //     // Turn on the camera
  //     setIsCameraOn(true);
  //     setButtonLabel("Capture");
  //   } else {
  //     // Capture the webcam image
  //     const imageSrc = webcamRef.current.getScreenshot();
  //     console.log("Captured Image:", imageSrc);

  //     if (imageSrc) {
  //       // Create an image element from the captured image
  //       const img = new Image();
  //       img.src = imageSrc;

  //       img.onload = async () => {
  //         // Create a canvas for image processing
  //         const canvas = document.createElement("canvas");
  //         canvas.width = img.width;
  //         canvas.height = img.height;
  //         const ctx = canvas.getContext("2d");

  //         // Draw the captured image on the canvas
  //         ctx.drawImage(img, 0, 0, img.width, img.height);

  //         // Initialize MediaPipe Selfie Segmentation
  //         const segmentation = new SelfieSegmentation({
  //           locateFile: (file) =>
  //             `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
  //         });

  //         segmentation.setOptions({
  //           modelSelection: 1, // General-purpose face segmentation model
  //         });

  //         // Perform segmentation
  //         await segmentation.initialize();
  //         const results = await new Promise((resolve) => {
  //           segmentation.onResults(resolve);
  //           segmentation.send({ image: img });
  //         });

  //         // Create a canvas for output
  //         const outputCanvas = document.createElement("canvas");
  //         outputCanvas.width = img.width;
  //         outputCanvas.height = img.height;
  //         const outputCtx = outputCanvas.getContext("2d");

  //         // Draw the original image
  //         outputCtx.drawImage(img, 0, 0, img.width, img.height);

  //         // Apply the segmentation mask
  //         outputCtx.globalCompositeOperation = "destination-in"; // Retain only the face
  //         outputCtx.drawImage(
  //           results.segmentationMask,
  //           0,
  //           0,
  //           img.width,
  //           img.height
  //         );

  //         // Reset the operation and apply a transparent background
  //         outputCtx.globalCompositeOperation = "destination-over";
  //         outputCtx.fillStyle = "transparent"; // Transparent background
  //         outputCtx.fillRect(0, 0, img.width, img.height);

  //         // Convert the processed image to Base64
  //         const base64Image = outputCanvas.toDataURL("image/png");

  //         // Set the profile image and form data
  //         setProfileImage(base64Image); // Display the processed image
  //         setFormData((prevData) => ({
  //           ...prevData,
  //           visitorPhoto: base64Image.split(",")[1], // Store Base64 (excluding metadata)
  //         }));

  //         console.log("Processed Image (Base64):", base64Image);
  //       };
  //     }

  //     // Turn off the camera and reset the button label
  //     setIsCameraOn(false);
  //     setButtonLabel("Take photo");
  //   }
  // };

  // // Function to handle image upload from the file input
  // const handleImageUpload = async (e) => {
  //   const file = e.target.files[0]; // Get the uploaded file
  //   if (!file) return;

  //   const reader = new FileReader();
  //   reader.onloadend = async () => {
  //     const img = new Image();
  //     img.src = reader.result;

  //     img.onload = async () => {
  //       // Create a canvas for image processing
  //       const canvas = document.createElement("canvas");
  //       canvas.width = img.width;
  //       canvas.height = img.height;
  //       const ctx = canvas.getContext("2d");

  //       // Draw the uploaded image on the canvas
  //       ctx.drawImage(img, 0, 0, img.width, img.height);

  //       // Initialize MediaPipe Selfie Segmentation
  //       const segmentation = new SelfieSegmentation({
  //         locateFile: (file) =>
  //           `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
  //       });

  //       segmentation.setOptions({
  //         modelSelection: 1, // General-purpose face segmentation model
  //       });

  //       // Perform segmentation
  //       await segmentation.initialize();
  //       const results = await new Promise((resolve) => {
  //         segmentation.onResults(resolve);
  //         segmentation.send({ image: img });
  //       });

  //       // Create a canvas for output
  //       const outputCanvas = document.createElement("canvas");
  //       outputCanvas.width = img.width;
  //       outputCanvas.height = img.height;
  //       const outputCtx = outputCanvas.getContext("2d");

  //       // Draw the original image
  //       outputCtx.drawImage(img, 0, 0, img.width, img.height);

  //       // Apply the segmentation mask
  //       outputCtx.globalCompositeOperation = "destination-in"; // Retain only the face
  //       outputCtx.drawImage(
  //         results.segmentationMask,
  //         0,
  //         0,
  //         img.width,
  //         img.height
  //       );

  //       // Reset the operation and apply a transparent background
  //       outputCtx.globalCompositeOperation = "destination-over";
  //       outputCtx.fillStyle = "transparent"; // Transparent background
  //       outputCtx.fillRect(0, 0, img.width, img.height);

  //       // Convert the processed image to Base64
  //       const base64Image = outputCanvas.toDataURL("image/png");

  //       // Update the processed image in state and form data
  //       setProfileImage(base64Image); // Display the processed image
  //       setFormData({ ...formData, visitorPhoto: base64Image.split(",")[1] });
  //       console.log("base64Image", base64Image.split(",")[1]);
  //       // Save Base64 (excluding metadata)
  //     };
  //   };

  //   reader.readAsDataURL(file); // Read the file as base64
  // };

  const [isPopupVisiblePrivacy, setPopupVisiblePrivacy] = useState(false);
  const [isPopupVisibleCovid, setPopupVisibleCovid] = useState(false);
  const [isCheckedB, setIsCheckedB] = useState(false);
  const [isCheckedP, setIsCheckedP] = useState(false);
  const [isCheckedC, setIsCheckedC] = useState(false);

  const handlePrivacyLinkClickPrivacy = () => {
    setPopupVisiblePrivacy(true);
  };

  const handleClosePopupPrivacy = () => {
    setPopupVisiblePrivacy(false);
  };

  const handlePrivacyLinkClickCovid = () => {
    setPopupVisibleCovid(true);
  };

  const handleClosePopupCovid = () => {
    setPopupVisibleCovid(false);
  };
  const handleCheckboxChangeB = (event) => {
    setIsCheckedB(event.target.checked);
  };
  const handleCheckboxChangeP = (event) => {
    setIsCheckedP(event.target.checked);
  };
  const handleCheckboxChangeC = (event) => {
    setIsCheckedC(event.target.checked);
  };

  const onClose = async (event) => {
    event.preventDefault();
    let valid = true;
    const errors = {};

    // if (formData.groupLeaderName === '') {
    //   errors.groupLeaderName = true;
    //   valid = false;
    // }
    if (formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (formData.gender === "") {
      errors.gender = true;
      valid = false;
    }
    if (formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    if (formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (formData.company === "") {
      errors.company = true;
      valid = false;
    }
    if (formData.selectedVisitorTypeId === "") {
      errors.selectedVisitorTypeId = true;
      valid = false;
    }
    if (formData.purpose === "") {
      errors.purpose = true;
      valid = false;
    }
    if (isadditionalNotify) {
      if (selectedEmails == "") {
        toast.error("please fill the message to notify field");
      }
    }
    if (formData.meetingFrom === null) {
      errors.meetingFrom = true;
      valid = false;
    }
    if (formData.meetingTo === null) {
      errors.meetingTo = true;
      valid = false;
    }
    if (formData.meetingVenue === "") {
      errors.meetingVenue = true;
      valid = false;
    }
    if (formData.gate === "") {
      errors.gate = true;
      valid = false;
    }
    if (formData.building === "") {
      errors.building = true;
      valid = false;
    }

    if (formData.visitorEmail !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.visitorEmail)) {
        errors.visitorEmail = true;
        valid = false;
      }
    }

    if (formData.visitorMobile === null) {
      errors.visitorMobile = true;
      valid = false;
    }
    if (!validateMeetingTimes()) {
      valid = false;
    }

    setFormErrors(errors);
    const toLocalISOString = (date) => {
      const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
      const localDate = new Date(date - tzOffset); // Apply the offset to get local time
      return localDate.toISOString().slice(0, -1); // Remove the 'Z' from the ISO string
    };
    localStorage.setItem("formData", JSON.stringify(formData)); // Save form data in local storage
    setFormData({
      firstName: existingData.groupLeaderName,
    });
    console.log("formData", formData);
    console.log("existingData.groupLeaderName", existingData.groupLeaderName);

    const formattedData = {
      ...formData,
      firstName: existingData.groupLeaderName,
      meetingFrom: toLocalISOString(new Date(formData.meetingFrom)),
      meetingTo: toLocalISOString(new Date(formData.meetingTo)),
      isAllDay: isAllDayChecked,
    };
    console.log("Form data:", formData);
    console.log("Form data:", formattedData);
    let recurrencePattern = getRecurrencePatternAPIValue();

    let newSelectedRecurrencePattern = "";

    // Determine the selected recurrence pattern based on the recurrencePatternAPI value
    if (recurrencePattern === 1) {
      newSelectedRecurrencePattern = "";
    } else if (recurrencePattern === 2) {
      newSelectedRecurrencePattern = selectedWeekday;
    } else if (recurrencePattern === 3) {
      newSelectedRecurrencePattern = selectedMonth;
    }

    // Log the new selected recurrence pattern before setting the state
    console.log(
      "Selected Recurrence Pattern before update:",
      newSelectedRecurrencePattern,
    );
    const formattedEmails = selectedEmails.join(", ");
    console.log("Submitting Emails:", formattedEmails);
    const formDataAdditional = {
      repeatVisit: isChecked,
      recurrencePattern: recurrencePatternAPI,
      selectedRecurrence: String(newSelectedRecurrencePattern),
      selectedDay: selectedDay,
      selectedWeekday: selectedWeekdayAPI,
      selectedMonth: selectedMonthAPI,
      recurEvery: recurEvery,
      isAllDay: isAllDayChecked,
      assistanceRequired: isAssistanceRequired,
      serviceProviderAccess: isServiceProviderAccess,
      wifiRequired: isWiFiRequired,
      escortRequired: isEscortRequired,
      additionalNotification: isadditionalNotify,
      additionalMessage: additionalMessage,
      checkInInstructions: checkInInstructions,
      notifyTo: formattedEmails,
    };

    // Log the object to the console
    console.log("Form Data formDataAdditional:", formDataAdditional);

    if (!valid) {
      setFormErrors(errors);
      toast.error("please fill all fields");
      console.log("Form has errors:", errors);
    } else {
      const formattedMobileNumber = `${defaultCode}-${formData.visitorMobile}`;
      console.log("Form data:", formData);
      const blackListCheck = await axiosInstance.get(
        `/BlackList/${formattedMobileNumber}`,
      );
      if (blackListCheck.data) {
        toast.error("Person with this mobile number is blacklisted");
        // Show the popup when the icon is clicked
      } else if (isCheckedP && isCheckedC) {
        navigate("/layout/group-appoinment-details", {
          state: { formattedData, formDataAdditional },
        });
        setPopupVisible(false);
      } else {
        toast.error("Please verify the privacy and covid fitness");
      }
    }
  };
  const onConfirm = async (event) => {
    event.preventDefault();
    let valid = true;
    const errors = {};

    // if (formData.groupLeaderName === '') {
    //   errors.groupLeaderName = true;
    //   valid = false;
    // }
    if (formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (formData.gender === "") {
      errors.gender = true;
      valid = false;
    }

    if (formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    if (formData.company === "") {
      errors.company = true;
      valid = false;
    }
    if (formData.selectedVisitorTypeId === "") {
      errors.selectedVisitorTypeId = true;
      valid = false;
    }
    if (formData.purpose === "") {
      errors.purpose = true;
      valid = false;
    }
    if (isadditionalNotify) {
      if (selectedEmails == "") {
        toast.error("please fill the message to notify field");
        return;
      }
    }
    if (formData.meetingFrom === null) {
      errors.meetingFrom = true;
      valid = false;
    }
    if (formData.meetingTo === null) {
      errors.meetingTo = true;
      valid = false;
    }
    if (formData.meetingVenue === "") {
      errors.meetingVenue = true;
      valid = false;
    }
    if (formData.gate === "") {
      errors.gate = true;
      valid = false;
    }
    if (formData.building === "") {
      errors.building = true;
      valid = false;
    }

    if (formData.visitorEmail !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.visitorEmail)) {
        errors.visitorEmail = true;
        valid = false;
      }
    }

    if (formData.visitorMobile === null) {
      errors.visitorMobile = true;
      valid = false;
    }
    if (!validateMeetingTimes()) {
      valid = false;
    }

    setFormErrors(errors);
    const toLocalISOString = (date) => {
      const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
      const localDate = new Date(date - tzOffset); // Apply the offset to get local time
      return localDate.toISOString().slice(0, -1); // Remove the 'Z' from the ISO string
    };
    localStorage.setItem("formData", JSON.stringify(formData)); // Save form data in local storage
    const formattedData = {
      ...formData,
      meetingFrom: toLocalISOString(new Date(formData.meetingFrom)),
      meetingTo: toLocalISOString(new Date(formData.meetingTo)),
      isAllDay: isAllDayChecked,
    };
    console.log("Form data:", formData);
    console.log("Form data:", formattedData);
    let recurrencePattern = getRecurrencePatternAPIValue();

    let newSelectedRecurrencePattern = "";

    // Determine the selected recurrence pattern based on the recurrencePatternAPI value
    if (recurrencePattern === 1) {
      newSelectedRecurrencePattern = "";
    } else if (recurrencePattern === 2) {
      newSelectedRecurrencePattern = selectedWeekday;
    } else if (recurrencePattern === 3) {
      newSelectedRecurrencePattern = selectedMonth;
    }

    // Log the new selected recurrence pattern before setting the state
    console.log(
      "Selected Recurrence Pattern before update:",
      newSelectedRecurrencePattern,
    );
    const formattedEmails = selectedEmails.join(", ");
    console.log("Submitting Emails:", formattedEmails);
    const formDataAdditional = {
      repeatVisit: isChecked,
      recurrencePattern: recurrencePatternAPI,
      selectedRecurrence: String(newSelectedRecurrencePattern),
      selectedDay: selectedDay,
      selectedWeekday: selectedWeekdayAPI,
      selectedMonth: selectedMonthAPI,
      recurEvery: recurEvery,
      isAllDay: isAllDayChecked,
      assistanceRequired: isAssistanceRequired,
      serviceProviderAccess: isServiceProviderAccess,
      wifiRequired: isWiFiRequired,
      escortRequired: isEscortRequired,
      additionalNotification: isadditionalNotify,
      notifyTo: formattedEmails,
      additionalMessage: additionalMessage,
      checkInInstructions: checkInInstructions,
    };

    // Log the object to the console
    console.log("Form Data formDataAdditional:", formDataAdditional);
    const formattedMobileNumber = `${defaultCode}-${formData.visitorMobile}`;
    if (!valid) {
      setFormErrors(errors);
      toast.error("please fill all fields");
      console.log("Form has errors:", errors);
    } else {
      console.log("Form data:", formData);
      const blackListCheck = await axiosInstance.get(
        `/BlackList/${formattedMobileNumber}`,
      );
      if (blackListCheck.data) {
        toast.error("Person with this mobile number is blacklisted");
        // Show the popup when the icon is clicked
      } else if (isCheckedP && isCheckedC) {
        navigate("/layout/group-appoinment-details", {
          state: { formattedData, formDataAdditional },
        });
      } else {
        toast.error("Please verify the privacy and covid fitness");
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (
        appointmentData &&
        appointmentData.length > 0 &&
        nationalityList &&
        nationalityList.length > 0
      ) {
        console.log("Prepopulated appointment data:", appointmentData);
        const prePopulateData = appointmentData[0];
        const matchedNationality = nationalityList.find(
          (nat) => nat.id === prePopulateData.nationalityId,
        );
        console.log("matchedNationality", matchedNationality);

        // Fetch visitor types
        const empId = localStorage.getItem("empIdOtp");
        let fetchedVisitorTypes = [];
        try {
          const response = await axiosInstance.get(
            `/VisitorType/GetVisitorTypeDetailsByEmpId/${empNameID}`,
          );
          fetchedVisitorTypes = response.data;
          setVisitorTypes(fetchedVisitorTypes);
        } catch (error) {
          console.error("Error fetching visitor types:", error);
        }

        const visitorTy = fetchedVisitorTypes.find(
          (type) => type.id === prePopulateData.selectedVisitorTypeId,
        );
        setFieldData(visitorTy?.groupAppointmentInputField[0]);

        // Fetch meeting venues
        const venuesResponse = await axiosInstance.get(
          `/Location/GetLocationByEmpId?empId=${empNameID}`,
        );
        const fetchedVenues = venuesResponse.data;
        setMeetingvenues(fetchedVenues);

        if (prePopulateData.meetingVenue) {
          const matchMeetingVenu = fetchedVenues.find(
            (venue) => venue.locationName === prePopulateData.meetingVenue,
          );

          if (matchMeetingVenu?.id) {
            const menuNameResponse = await axiosInstance.get(
              `/Location/GetGatesByLocationID?locationID=${matchMeetingVenu.id}`,
            );
            const fetchedGates = menuNameResponse.data;
            setGates(fetchedGates);

            const selectedGateObject = fetchedGates.find(
              (gate) => gate.id === prePopulateData.gateId,
            );
            setSelectedGate(selectedGateObject);

            // if (selectedGateObject?.id) {
              // const buildingsResponse = await axiosInstance.get(
              //   `/Location/GetBuidingsByGateID?gateID=${selectedGateObject.id}`,
              // );
              // const fetchedBuildings = buildingsResponse.data;
              const buildingsResponse = await axiosInstance.get(
                  `/Location/GetBuildingAndGateByLocationId/${matchMeetingVenu.id}`,
              );
              const fetchedBuildings = buildingsResponse.data?.data?.buildings || [];
              setBuildings(fetchedBuildings);

              const matchedBuilding = fetchedBuildings.find(
                (bld) => bld.name === prePopulateData.building,
              );

              setFormData((prevFormData) => ({
                ...prevFormData,
                gate: selectedGateObject.name,
                building: matchedBuilding?.name || "",
              }));
            // }
          }
        }

        // Set rest of the form data
        setFormData((prevData) => ({
          ...prevData,
          firstName: prePopulateData.firstName || "",
          middleName: prePopulateData.middleName || "",
          lastName: prePopulateData.lastName || "",
          selectedVisitorTypeId: prePopulateData?.selectedVisitorTypeId || "",
          visitorEmail: prePopulateData.visitorEmail || "",
          visitorMobile: prePopulateData.visitorMobile || "",
          gender: prePopulateData.gender || "",
          meetingVenue: prePopulateData.meetingVenue || "",
          meetingFrom: prePopulateData.createdDate
            ? new Date(prePopulateData.appointmentDate)
            : "",
          meetingTo: prePopulateData.validTill
            ? new Date(prePopulateData.validTill)
            : "",
          purpose: prePopulateData.purpose || "",
          idProofNo: prePopulateData.idProofNo || "",
          selectedIdProofTypeId: prePopulateData.idProofType || "",
          nationality: matchedNationality?.name || "",
          nationalityCode: prePopulateData?.nationalityCode || "",
        }));

        setDefaultCode(matchedNationality?.nationalityCode);
      }
    };

    fetchData();
  }, [appointmentData, nationalityList]); // <== important!

  //acknowladge feature
  const [entity, setEntity] = useState([]); // Properly initialized as an empty array
  const [ackChecklist, setAckChecklist] = useState({});

  const [detailsValid, setDetailsValid] = useState(false); // controls Acknowledge tab enable
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [passACKData, setPassACKData] = useState("");
  const empId = localStorage.getItem("employeeId");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openPdfModal, setOpenPdfModal] = useState(false);
  const [agreedRows, setAgreedRows] = useState({});

  useEffect(() => {
    if (!entityID) return;
    const fetchAppointmentDataeempEntity = async () => {
      try {
        const responseEntity = await axiosInstance.get(
          `/Entity/GetEntityByID/${entityID}`,
        );
        const selectedEntity = responseEntity?.data;

        // If you want to keep it in state for modal usage:
        setEntity(responseEntity?.data);

        // Dynamically build the checklist based on what exists in the entity
        const initialChecklist = {};

        if (
          selectedEntity?.uploadTrainingVideos &&
          selectedEntity?.trainingVideosLink
        )
          initialChecklist.training = false;

        if (
          selectedEntity?.uploadSafetyGuidelinesDocuments &&
          selectedEntity?.safetyGuidelines?.safetyGuidelinesDocumentLink
        )
          initialChecklist.safetyDoc = false;

        if (
          selectedEntity?.uploadSafetyGuidelinesDocuments &&
          selectedEntity?.safetyGuidelines?.safetyGuidelinesVideoLink
        )
          initialChecklist.safetyVideo = false;

        if (selectedEntity?.ndaDocument) initialChecklist.ndaDoc = false;

        // Set it in state
        setAckChecklist(initialChecklist);
      } catch (error) {
        console.error("Error fetching appointment data:", error);
      }
    };
    fetchAppointmentDataeempEntity();
  }, [entityID]);

  return (
    <Container>
      {loading && <Loader />}
      <Header>
        <Heading>Group Leader Application Form</Heading>
        <ButtonGroup>
          {activeTab == "details" ? (
            <ResetButton onClick={handleReset}>Reset</ResetButton>
          ) : (
            <ResetButton onClick={handleResetAcknowledgement}>
              Reset
            </ResetButton>
          )}

          {activeTab === "details" ? (
            <SubmitButton
              onClick={handleNext}
              disabled={isSubmitted || loading}
            >
              {loading ? "Submitting" : "Next"}
            </SubmitButton>
          ) : (
            <SubmitButton
              onClick={handleSubmit}
              disabled={isSubmitted || loading}
            >
              {loading ? "Submitting" : "Next"}
            </SubmitButton>
          )}
        </ButtonGroup>
      </Header>
      <Tabs>
        <Tab
          active={activeTab === "details"}
          onClick={() => setActiveTab("details")}
        >
          Details
        </Tab>
        {/* <Tab active={activeTab === 'additional'} onClick={() => setActiveTab('additional')}>
          Additional
        </Tab> */}
        <Tab
          active={activeTab === "acknowledge"}
          disabled={!detailsValid} // disable until details are valid
          onClick={() => setActiveTab("acknowledge")}
        >
          Acknowledgement
        </Tab>
      </Tabs>
      <TabContent active={activeTab === "details"}>
        <CardContainer>
          <Card>
            <FormGroup>
              <Label>
                Visitor Type
                <Asterisk> *</Asterisk>
              </Label>
              <Select
                name="selectedVisitorTypeId"
                value={formData.selectedVisitorTypeId}
                onChange={handleChangeNew}
                disabled={formData.selectedVisitorTypeId ? true : false} // Disable input based on condition
              >
                <option value="">Select type</option>
                {visitorTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.visitorTypeDesc}
                  </option>
                ))}
              </Select>
            </FormGroup>
            {/* <FormGroup>
              <Label>
                Group Leader Name<Asterisk> *</Asterisk>
              </Label>
              <Input
                type="text"
                name="groupLeaderName"
                value={formData.groupLeaderName}
                onChange={(e) => {
                  const value = e.target.value;
                  // Regular expression to only allow alphabets and spaces
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChange(e); // Only update state if input is valid
                  }
                }}
                placeholder="Enter Group Leader Name"
                style={{
                  borderBottomColor: formErrors.groupLeaderName ? 'red' : '#2b3497',
                }}
              />
              {formErrors.groupLeaderName && (
                <span style={{ color: 'red', fontSize: '12px' }}>Please fill in the group leader name</span>
              )}
            </FormGroup> */}
            <FormRow>
              <FormGroup>
                <Label>
                  First Name
                  {fieldData?.visitorNameField && <Asterisk> *</Asterisk>}
                </Label>
                <Input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Regular expression to only allow alphabets and spaces
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleChange(e); // Only update state if input is valid
                    }
                  }}
                  placeholder="Enter First Name"
                  style={{
                    borderColor: formErrors.firstName ? "red" : "#2B3497",
                  }}
                  disabled={fieldData?.visitorNameField} // Disable input based on condition
                />
              </FormGroup>

              <FormGroup>
                <Label>Middle Name</Label>
                <Input
                  type="text"
                  name="middleName"
                  value={formData.middleName}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Regular expression to only allow alphabets and spaces
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleChange(e); // Only update state if input is valid
                    }
                  }}
                  placeholder="Enter Middle Name (Optional)"
                  style={{ borderColor: "#2B3497" }}
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  Last Name
                  {fieldData?.visitorNameField && <Asterisk> *</Asterisk>}
                </Label>
                <Input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Regular expression to only allow alphabets and spaces
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleChange(e); // Only update state if input is valid
                    }
                  }}
                  placeholder="Enter Last Name"
                  style={{
                    borderColor: formErrors.lastName ? "red" : "#2B3497",
                  }}
                  disabled={fieldData?.visitorNameField} // Disable input based on condition
                />
              </FormGroup>
            </FormRow>
            <FormGroup>
              <Label>
                Visitor Email{" "}
                {fieldData?.visitorEmailField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="email"
                name="visitorEmail"
                value={formData.visitorEmail}
                placeholder="Enter Email"
                onChange={handleInputChange}
                style={{
                  borderBottomColor: formErrors.visitorEmail
                    ? "red"
                    : "#2b3497",
                }}
                disabled={fieldData?.visitorEmailField} // Disable input based on condition
              />
              {formErrors.visitorEmail && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formData.visitorEmail
                    ? "Invalid email format"
                    : "Please fill in the visitor email"}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Gender
                {fieldData?.genderField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                disabled={fieldData?.genderField} // Disable input based on condition
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="other">Other</option>
              </Select>
              {formErrors.gender && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a gender
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Nationality
                {fieldData?.nationalityField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="nationality"
                value={formData.nationality}
                onChange={(e) => {
                  const selectedNationality = nationalityList.find(
                    (n) => n.name === e.target.value,
                  );
                  setFormData({
                    ...formData,
                    nationality: e.target.value,
                    visitorMobile: "",
                  });
                  setDefaultCode(selectedNationality.nationalityCode);
                }}
                disabled={fieldData?.nationalityField} // Disable input based on condition
              >
                <option value="">Select Nationality</option>
                {nationalityList.map((nationality) => (
                  <option
                    key={nationality.id}
                    value={nationality.name}
                    disabled={nationality.isBlackListed}
                  >
                    {nationality.name}
                  </option>
                ))}
              </Select>
              {formErrors.nationality && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a nationality
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Visitor Mobile{" "}
                {fieldData?.visitorMobileField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="visitorMobile"
                value={formData.visitorMobile}
                placeholder="Enter  mobile number"
                maxLength={defaultCode === "91" ? 10 : 15}
                onChange={handleInputChange}
                style={{
                  borderBottomColor: formErrors.visitorMobile
                    ? "red"
                    : "#2b3497",
                }}
                disabled={fieldData?.visitorMobileField} // Disable input based on condition
              />
              {formErrors.visitorMobile && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formData.visitorMobile
                    ? "Invalid mobile number"
                    : "Please fill in the mobile number"}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Location
                {fieldData?.locationField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="meetingVenue"
                value={formData.meetingVenue} // Ensure this is correctly mapped
                onChange={handleChangeLo}
                disabled={fieldData?.locationField} // Disable input based on condition
              >
                <option value="">Select Location</option>
                {meetingvenues.map((type) => (
                  <option key={type.locationName} value={type.locationName}>
                    {type.locationName}
                  </option>
                ))}
              </Select>
              {formErrors.meetingVenue && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a meeting venue
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Gate
                {fieldData?.gateField && <Asterisk> *</Asterisk>}{" "}
              </Label>
              <Select
                name="gate"
                value={selectedGate ? selectedGate.id : ""}
                onChange={handleGateChange}
                disabled={fieldData?.gateField} // Disable input based on condition
              >
                <option value="">Select Gate</option>
                {gates.map((gate) => (
                  <option key={gate.id} value={gate.id}>
                    {gate.name}
                  </option>
                ))}
              </Select>
              {formErrors.gate && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a gate
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Area
                {fieldData?.areaField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="building"
                value={formData.building}
                onChange={handleChange}
                disabled={fieldData?.areaField} // Disable input based on condition
              >
                <option value="">Select Area</option>
                {Array.isArray(buildings) &&
                  buildings.map((building) => (
                    <option key={building.id} value={building.name}>
                      {building.name}
                    </option>
                  ))}
              </Select>
              {formErrors.building && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a building
                </span>
              )}
            </FormGroup>
          </Card>
          <Card>
            <FormGroup>
              <Label>
                Meeting On
                {fieldData?.meetingOnField && <Asterisk> *</Asterisk>}
              </Label>
              <StyledDatePicker
                selected={
                  formData.meetingFrom instanceof Date
                    ? formData.meetingFrom
                    : null
                }
                onChange={(date) => handleDateChange(date, "meetingFrom")}
                showTimeSelect
                dateFormat="Pp"
                minDate={currentDateTime}
                filterTime={filterPassedTime}
                timeClassName={highlightTime}
                placeholderText="Select Meeting Start Date and Time"
                disabled={fieldData?.meetingOnField} // Disable input based on condition
              />
              {formErrors.meetingFrom && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a meeting start time
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Meeting To
                {fieldData?.meetingToField && <Asterisk> *</Asterisk>}{" "}
              </Label>
              <StyledDatePicker
                selected={
                  formData.meetingTo instanceof Date ? formData.meetingTo : null
                }
                onChange={(date) => handleDateChange(date, "meetingTo")}
                showTimeSelect
                dateFormat="Pp"
                minDate={formData.meetingFrom || currentDateTime} // Ensure meetingTo is after meetingFrom
                filterTime={filterPassedTime}
                timeClassName={highlightTime}
                placeholderText="Select Meeting End Date and Time"
                disabled={fieldData?.meetingToField} // Disable input based on condition
              />
              {formErrors.meetingTo && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a meeting end time
                </span>
              )}
            </FormGroup>
            {/* <AdditionalInputContainerN>
            <CheckboxContainer>
              <CheckboxLabel>All Day</CheckboxLabel>
              <Checkbox type="checkbox" checked={isAllDayChecked} onChange={handleAllDayCheckboxChange} />
            </CheckboxContainer>
          </AdditionalInputContainerN> */}

            <FormGroup>
              <Label>
                Id Proof Type{" "}
                {fieldData?.idProofTypeField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="selectedIdProofTypeId"
                value={formData.selectedIdProofTypeId}
                onChange={handleChange}
                disabled={fieldData?.idProofTypeField} // Disable input based on condition
              >
                <option value="">Select ID Proof Type</option>
                {idProofTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.idProofDescription}
                  </option>
                ))}
              </Select>
              {formErrors.selectedIdProofTypeId && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a Id Prood type
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Id Proof Number
                {fieldData?.idProofNumberField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="idProofNo"
                maxLength={4}
                placeholder="Enter Id Proof Number"
                value={formData.idProofNo}
                disabled={fieldData?.idProofNumberField} // Disable input based on condition
                onChange={(e) => {
                  const regex = /^[a-zA-Z0-9]*$/; // Allows only alphanumeric characters
                  if (regex.test(e.target.value)) {
                    handleInputChange(e); // Call the original handler if valid
                  }
                }}
              />
              {formErrors.idProofNo && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please Fill the Id Proof Number
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Purpose
                {fieldData?.purpose && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="purpose"
                value={formData.purpose}
                onChange={handleChange}
                placeholder="Enter Purpose"
                disabled={fieldData?.purpose} // Disable input based on condition
              />
              {formErrors.purpose && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please fill in the purpose
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Visitor Company<Asterisk> *</Asterisk>
              </Label>
              <Input
                type="text"
                name="company"
                placeholder="Enter Company"
                value={formData.company}
                onChange={handleInputChange}
              />
              {formErrors.company && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please fill in the company name
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Host Name<Asterisk> *</Asterisk>
              </Label>
              <Input
                type="text"
                name="hostname"
                value={empName}
                placeholder="Enter Host name"
                onChange={handleInputChange}
                disabled={true} // Disable input based on condition
              />
            </FormGroup>
            <FormGroup>
              <Label>Vehicle No</Label>
              <Input
                type="text"
                name="vehicleno"
                placeholder="Enter Vehicle No"
                value={formData.vehicleno}
                onChange={handleInputChange}
              />
            </FormGroup>
          </Card>
          <ProfileCard>
            <VisitorPhotoHeading>Visitor Photo</VisitorPhotoHeading>
            <ProfileText>(Only JPEG and PNG Images)</ProfileText>
            <Circle>
              <WebcamContainer>
                {isCameraOn && (
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    width="100%"
                    height="100%"
                    videoConstraints={{
                      width: 200,
                      height: 200,
                      facingMode: "user",
                    }}
                  />
                )}
                {!isCameraOn && profileImage && (
                  <img
                    src={profileImage}
                    alt="Profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                    }}
                  />
                )}
                {!isCameraOn && !profileImage && (
                  <ProfileIcon>
                    <User size={40} />
                  </ProfileIcon>
                )}
              </WebcamContainer>
            </Circle>
            <ButtonRow>
              <PhotoButton onClick={handleCapture}>{buttonLabel}</PhotoButton>
            </ButtonRow>
            <ButtonRow>
              <ActionButton onChange={handleImageUpload}>
                <label htmlFor="upload-button" style={{ cursor: "pointer" }}>
                  Upload images
                </label>
              </ActionButton>
            </ButtonRow>
            <input
              id="upload-button"
              ref={fileInputRef} // ✅ connect the ref
              type="file"
              accept="image/png, image/jpeg"
              style={{ display: "none" }}
              onChange={handleImageUpload}
            />

            <CheckboxRowContainer>
              <CheckboxContainer>
                <input
                  type="checkbox"
                  checked={isCheckedP}
                  onChange={handleCheckboxChangeP}
                />
                <span>
                  <PrivacyLink onClick={handlePrivacyLinkClickPrivacy}>
                    Privacy Policy<span style={{ color: "red" }}> *</span>
                  </PrivacyLink>
                </span>
              </CheckboxContainer>
              <CheckboxContainer>
                <input
                  type="checkbox"
                  checked={isCheckedC}
                  onChange={handleCheckboxChangeC}
                />
                <span>
                  <PrivacyLink onClick={handlePrivacyLinkClickCovid}>
                    COVID Fitness<span style={{ color: "red" }}> *</span>
                  </PrivacyLink>
                </span>
              </CheckboxContainer>
            </CheckboxRowContainer>
          </ProfileCard>
        </CardContainer>
      </TabContent>
      <TabContent active={activeTab === "acknowledge"}>
        <CardContainer>
          <Card>
            {(entity?.uploadTrainingVideos && entity?.trainingVideosLink) ||
            (entity?.uploadSafetyGuidelinesDocuments &&
              (entity?.safetyGuidelines?.safetyGuidelinesDocumentLink ||
                entity?.safetyGuidelines?.safetyGuidelinesVideoLink)) ||
            entity?.ndaDocument ? (
              <>
                {/* Training Videos */}
                {entity?.uploadTrainingVideos && entity?.trainingVideosLink && (
                  <AckItem>
                    {/* Checkbox only controls state */}
                    <input
                      type="checkbox"
                      id="training"
                      checked={ackChecklist?.training || false}
                      onChange={(e) =>
                        setAckChecklist({
                          ...ackChecklist,
                          training: e.target.checked,
                        })
                      }
                    />

                    <AckText>
                      I acknowledge I have watched the{" "}
                      <span
                        style={{
                          color: "#293495",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.preventDefault(); // prevent checkbox toggle when clicking link
                          setVideoUrl(entity.trainingVideosLink);
                          setOpenVideoModal(true);
                        }}
                      >
                        Training Video
                      </span>
                    </AckText>
                  </AckItem>
                )}

                {/* Safety Guidelines Document */}
                {entity?.uploadSafetyGuidelinesDocuments &&
                  entity?.safetyGuidelines?.safetyGuidelinesDocumentLink && (
                    <AckItem htmlFor="safetyDoc">
                      <input
                        type="checkbox"
                        id="safetyDoc"
                        checked={ackChecklist?.safetyDoc || false}
                        onChange={(e) =>
                          setAckChecklist({
                            ...ackChecklist,
                            safetyDoc: e.target.checked,
                          })
                        }
                      />
                      <AckText>
                        I acknowledge I have read the{" "}
                        <span
                          style={{
                            color: "#293495",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault(); // don't let it trigger link behavior
                            setShowPdfModal(true);
                          }}
                          href={
                            entity.safetyGuidelines.safetyGuidelinesDocumentLink
                          }
                          target="_self"
                          rel="noopener noreferrer"
                        >
                          Safety Guidelines Document
                        </span>
                      </AckText>
                    </AckItem>
                  )}

                {/* Safety Guidelines Video */}
                {entity?.uploadSafetyGuidelinesDocuments &&
                  entity?.safetyGuidelines?.safetyGuidelinesVideoLink && (
                    <AckItem>
                      {/* Checkbox only controls state */}
                      <input
                        type="checkbox"
                        id="safetyVideo"
                        checked={ackChecklist.safetyVideo || false}
                        onChange={(e) =>
                          setAckChecklist({
                            ...ackChecklist,
                            safetyVideo: e.target.checked,
                          })
                        }
                      />

                      <AckText>
                        I acknowledge I have watched the{" "}
                        <span
                          style={{
                            color: "#293495",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault(); // don't let it trigger link behavior
                            setVideoUrl(
                              entity?.safetyGuidelines
                                ?.safetyGuidelinesVideoLink,
                            );
                            setOpenVideoModal(true);
                          }}
                        >
                          Safety Guidelines Video
                        </span>
                      </AckText>
                    </AckItem>
                  )}
                {entity?.ndaDocument && (
                  <AckItem>
                    <input
                      type="checkbox"
                      id="ndaDoc"
                      checked={ackChecklist.ndaDoc || false}
                      style={{ cursor: "not-allowed" }}
                      // disabled
                      // onChange={(e) =>
                      //   setAckChecklist({
                      //     ...ackChecklist,
                      //     ndaDoc: e.target.checked,
                      //   })
                      // }
                    />
                    <AckText>
                      I acknowledge I have read the{" "}
                      <span
                        style={{
                          color: "#293495",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={async (e) => {
                          e.preventDefault();
                          setLoading(true);
                          try {
                            const requestData = {
                              idProofNumber: formData?.idProofNo,
                              hostID: parseInt(empNameID),
                              visitorName:
                                formData?.firstName +
                                (formData?.middleName != null
                                  ? " " + formData.middleName
                                  : "") +
                                " " +
                                formData?.lastName +
                                " + G",
                              visitorMobile: formData?.visitorMobile,
                              visitorCompany: formData?.company,
                              nationalityCode: formData?.nationalityCode,
                              ndadDocumentToken: "",
                              iAccpect: true,
                              checkInDateTime: new Date(),
                              VisitorType: String(
                                formData?.selectedVisitorTypeId,
                              ),
                            };

                            const response = await axiosInstance.post(
                              "/Entity/GetNDADocumentByVisitorDetails",
                              [requestData],
                            );

                            if (response.data && response.data.length > 0) {
                              const ndaPath = response.data[0].NDADocumentPath;

                              const fileResponse = await axiosInstance.get(
                                `/document/Documentdownload?token=${encodeURIComponent(
                                  ndaPath,
                                )}`,
                                { responseType: "blob" },
                              );

                              const pdfBlobUrl = window.URL.createObjectURL(
                                new Blob([fileResponse.data], {
                                  type: "application/pdf",
                                }),
                              );

                              setPdfUrl(pdfBlobUrl);
                              setSelectedRowId(entity.id);
                              setOpenPdfModal(true);
                              setLoading(false);
                            } else {
                              toast.error("No NDA document found.");
                              setLoading(false);
                            }
                          } catch (error) {
                            console.error(
                              "Error fetching NDA document:",
                              error,
                            );
                            setLoading(false);
                            toast.error("Failed to fetch the NDA document.");
                          } finally {
                            setLoading(false);
                          }
                        }}
                      >
                        NDA Document
                      </span>
                    </AckText>
                  </AckItem>
                )}
                {/* {ackChecklist.ndaDoc && (
                      <FormGroup>
                        <Label>
                          NDA Document
                        </Label>
      
                        <FileUploadContainer>
                          <CustomFileButton
                            onClick={() =>
                              document.getElementById("transportVendorFileInput").click()
                            }
                          >
                            Choose File
                          </CustomFileButton>
      
                          <FileNameInput
                            type="text"
                            value={transportVendorFileName || ""}
                            placeholder="No file chosen"
                            readOnly
                          />
      
                          <HiddenFileInput
                            id="transportVendorFileInput"
                            type="file"
                            accept=".pdf,.doc,.docx"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setTransportVendorFileName(file.name);
      
                                try {
                                  const base64String = await fileToBase64(file);
                                  setTransportVendorFileBase64(base64String); // store base64 string
                                } catch (err) {
                                  console.error("File conversion error:", err);
                                }
                              }
                            }}
                          />
                        </FileUploadContainer>
                      </FormGroup>
                    )} */}
              </>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "2rem",
                  color: "#555",
                  fontSize: "1rem",
                }}
              >
                No acknowledgment materials are available at the moment.
              </div>
            )}
          </Card>
          {openPdfModal && (
          <PdfModalOverlay>
            <PdfModalContent>
              <CloseButtonIcon onClick={() => setOpenPdfModal(false)}>
                ✖
              </CloseButtonIcon>
              <PdfFrame src={pdfUrl} title="NDA Document" />
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
                <AgreeButton
                  onClick={() => setShowSignatureModal(true)} // ✅ Opens Signature Modal
                >
                  I Agree
                </AgreeButton>
              </div>
            </PdfModalContent>
          </PdfModalOverlay>
        )}

        {showSignatureModal && (
            <PdfModalOverlay>
              <PdfModalContent style={{ maxWidth: "500px" }}>
                <CloseButtonIcon onClick={() => {
                  setShowSignatureModal(false);
                  if (sigCanvasRef.current) sigCanvasRef.current.clear();
                }}>
                  ✖
                </CloseButtonIcon>

                <h3 style={{ marginBottom: "10px", color: "#293495" }}>
                  Your Signature
                </h3>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "12px" }}>
                  Please sign below to acknowledge the NDA Document. (Optional)
                </p>

                {/* Signature Canvas */}
                <div style={{
                  border: "1px solid #2b3497",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginBottom: "12px",
                  background: "#f9f9f9"
                }}>
                  <SignatureCanvas
                    ref={sigCanvasRef}
                    penColor="black"
                    canvasProps={{
                      width: 450,
                      height: 200,
                      style: { display: "block" }
                    }}
                  />
                </div>

                {/* Clear + Confirm buttons */}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <button
                    onClick={() => sigCanvasRef.current?.clear()}
                    style={{
                      padding: "8px 16px",
                      border: "2px solid #293495",
                      borderRadius: "6px",
                      background: "transparent",
                      color: "#293495",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    Clear
                  </button>

                  <button
                    style={{
                      padding: "8px 16px",
                      background: "#293495",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = "#1f276f"}
                    onMouseLeave={(e) => e.currentTarget.style.background = "#293495"}
                    onClick={async () => {
                      const isSigned = sigCanvasRef.current && !sigCanvasRef.current.isEmpty();
                      const signatureDataURL = isSigned
                        ? sigCanvasRef.current.getCanvas().toDataURL("image/png")
                        : null;

                      if (isSigned) {
                        console.log("Signature captured:", {
                          visitorName: `${formData.firstName} ${formData.lastName}`,
                          visitorMobile: formData.visitorMobile,
                          signedAt: new Date().toISOString(),
                          signatureBase64: signatureDataURL,
                        });
                      }
                      setNDASignature(signatureDataURL);

                      setShowSignatureModal(false);
                      if (sigCanvasRef.current) sigCanvasRef.current.clear();

                      // If no signature — skip API, mark agreed directly
                      if (!isSigned) {
                        setAckChecklist((prev) => ({ ...prev, ndaDoc: true }));
                        setAgreedRows((prev) => ({ ...prev, [selectedRowId]: true }));
                        setOpenPdfModal(false);
                        toast.success("You agreed to the NDA.");
                        return;
                      }

                      // Signature provided — call API with NDASignature
                      setLoading(true);
                      try {
                        const requestData = {
                          idProofNumber: formData?.idProofNo,
                          hostID: parseInt(empNameID),
                          visitorName:
                            formData?.firstName +
                            (formData?.middleName != null ? " " + formData.middleName : "") +
                            " " +
                            formData?.lastName +
                            " + G",
                          visitorMobile: formData?.visitorMobile,
                          visitorCompany: formData?.company,
                          nationalityCode: formData?.nationalityCode,
                          ndadDocumentToken: "",
                          iAccpect: true,
                          checkInDateTime: new Date(),
                          VisitorType: String(formData?.selectedVisitorTypeId),
                          NDASignature: signatureDataURL, // ✅ base64 signature
                        };

                        const response = await axiosInstance.post(
                          "/Entity/GetNDADocumentByVisitorDetails",
                          [requestData]
                        );

                        if (response.data && response.data.length > 0) {
                          const ndaPath = response.data[0].NDADocumentPath;

                          const fileResponse = await axiosInstance.get(
                            `/document/Documentdownload?token=${encodeURIComponent(ndaPath)}`,
                            { responseType: "blob" }
                          );

                          const updatedPdfBlobUrl = window.URL.createObjectURL(
                            new Blob([fileResponse.data], { type: "application/pdf" })
                          );

                          // Update PDF in modal, mark agreed, close modals
                          setPdfUrl(updatedPdfBlobUrl);
                          setAckChecklist((prev) => ({ ...prev, ndaDoc: true }));
                          setAgreedRows((prev) => ({ ...prev, [selectedRowId]: true }));
                          setOpenPdfModal(false);
                          toast.success("You agreed to the NDA.");
                        } else {
                          toast.error("No NDA document found.");
                        }
                      } catch (error) {
                        console.error("Error applying signature:", error);
                        toast.error("Failed to apply signature.");
                      } finally {
                        setLoading(false);
                      }
                    }}
                  >
                    Confirm
                  </button>
                </div>
              </PdfModalContent>
            </PdfModalOverlay>
          )}

          {openVideoModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2000, // ensure above everything
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "80%",
                  maxWidth: "900px",
                  background: "#000",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                {/* Close button */}
                <button
                  onClick={() => {
                    setOpenVideoModal(false);
                    setVideoUrl(""); // clear video when closing
                  }}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    fontSize: "22px",
                    background: "transparent",
                    border: "none",
                    color: "#fff",
                    cursor: "pointer",
                    zIndex: 2100,
                  }}
                >
                  ✖
                </button>

                {/* Video Player */}
                {videoUrl.includes("youtube.com") ||
                videoUrl.includes("youtu.be") ? (
                  <iframe
                    width="100%"
                    height="500"
                    src={
                      videoUrl.includes("watch?v=")
                        ? videoUrl.replace("watch?v=", "embed/")
                        : videoUrl.replace("youtu.be/", "youtube.com/embed/")
                    }
                    title="Training Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <video width="100%" height="500" controls autoPlay>
                    <source src={videoUrl} type="video/mp4" />
                    Your browser does not support HTML5 video.
                  </video>
                )}
              </div>
            </div>
          )}
        </CardContainer>
        {showPdfModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2000, // ensure above everything
              cursor: "pointer",
            }}
            onClick={() => setShowPdfModal(false)}
          >
            <div
              style={{
                position: "relative",
                width: "80%",
                maxWidth: "1120px",
                height: "80%",
                background: "#000",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                }}
              >
                S
                <CloseButton onClick={() => setShowPdfModal(false)}>
                  ✖
                </CloseButton>
              </div>
              <iframe
                src={entity?.safetyGuidelines?.safetyGuidelinesDocumentLink}
                width="100%"
                height="100%"
                title="Safety Guidelines"
              />
            </div>
          </div>
        )}
      </TabContent>

      {isPopupVisiblePrivacy && (
        <PopupOverlay>
          <PopupContent>
            <h3>Privacy Policy</h3>
            {entity?.privacyPolicy ? (
              <div>{entity?.privacyPolicy}</div>
            ) : (
              <div>
                <p>
                  While visiting facilities ("Facilities"), the visitor may have
                  access to or receive some information that is secret or
                  proprietary to Fidrox (collectively ‘Company’) concerning
                  their business or technology. The visitor undertakes to adhere
                  by the rules of this Agreement respecting the confidentiality
                  of any Confidential Information to which he or she has access
                  or receives.
                </p>
                <p>
                  “Confidential Information”: for purpose of this Agreement
                  shall mean and include, any and all information in written,
                  electronic, verbal or other form relating directly or
                  indirectly to the present or potential business, operation or
                  financial condition of or relating including, but not limited
                  to, information pertaining to pricing, marketing plans or
                  strategy, volumes, services rendered, customers and suppliers
                  lists, financial or technical or service matters or data,
                  trade secrets, designs, programming codes, personal or
                  sensitive data of any related parties, intellectual property,
                  and any information which might reasonably be presumed to be
                  proprietary or confidential in nature and also includes all
                  information identified by Company as confidential.
                </p>
                <p>I agree that:</p>
                <ul>
                  <li>
                    I have access to confidential information, I shall not
                    release, publish, or disclose such information to
                    unauthorized personnel. I shall protect such information and
                    will employ all reasonable efforts to maintain the
                    confidentiality of such information.
                  </li>
                  <li>
                    I shall immediately notify the Company-security personnel of
                    any suspected or confirmed unauthorized disclosure and/or
                    misuse of confidential information.
                  </li>
                  <li>
                    I shall not make any sound recordings, take any photographs
                    or make any movies, copies or reproductive images (in any
                    medium) of anything at the facility (ies); Upon Company’s
                    request, I shall promptly return all Confidential
                    Information received from Company together with all copies,
                    or certify in writing that all such Confidential Information
                    and copies thereof have been destroyed.
                  </li>
                  <li>
                    While entering Company data center, I consent for my
                    personal body and my belongings (baggage, luggage,
                    electronic gadgets, etc.) for security frisking purposes.
                  </li>
                  <li>
                    Company may collect certain personal information with
                    relation to the purpose of this agreement that is visiting
                    data center(s). I acknowledge it in detail at{" "}
                    <a
                      href="https://www.fidrox.com/privacy-policy/"
                      target="_blank"
                    >
                      https://www.fidrox.com/privacy-policy/
                    </a>
                    .
                  </li>
                  <li>
                    This Agreement shall remain in effect until such time as all
                    Confidential Information of Company disclosed hereunder
                    becomes publicly known without my action or inaction.
                  </li>
                </ul>
              </div>
            )}
            <ButtonContainer>
              <CloseButton onClick={handleClosePopupPrivacy}>Close</CloseButton>
            </ButtonContainer>
          </PopupContent>
        </PopupOverlay>
      )}
      {isPopupVisibleCovid && (
        <PopupOverlay>
          <PopupContent>
            <h3>Covid Fitness</h3>
            {entity?.covidFitness ? (
              <p>{entity?.covidFitness}</p>
            ) : (
              <p>
                The basic preventive measures include simple public health
                measures that are to be followed to reduce the risk of infection
                with COVID-19. These measures need to be observed by all
                (employees and visitors) at all times. These include: Physical
                distancing of at least one meter to be followed at all times.
                Use of face covers/masks to be mandatory. Practice frequent hand
                washing (for at least 40-60 seconds) even when hands are not
                visibly dirty and use of alcohol based hand sanitizers (for at
                least 20 seconds). Respiratory etiquettes to be strictly
                followed. This involves strict practice of covering one’s mouth
                and nose while coughing/sneezing with a
                tissue/handkerchief/flexed elbow and disposing off used tissues
                properly. Self-monitoring of health by all and reporting any
                illness at the earliest.Place the ill person in a room or area
                where they are isolated from others at the workplace. Provide a
                mask/face cover till such time he/she is examined by a doctor.
                Report to concerned central/state health authorities. Helpline
                1075 will be immediately informed. A risk assessment will be
                undertaken by the designated public health authority (district
                RRT/treating physician) and accordingly further advice shall be
                made regarding management of case, his/her contacts and need for
                disinfection. The suspect case if reporting very mild / mild
                symptoms on assessment by the health authorities would be placed
                under home isolation, subject to fulfilment of criteria laid
                down in MoHFW guidelines. Suspect case, if assessed by health
                authorities as moderate to severe, he/she will follow guidelines
                as laid down by MoHFW. The rapid response team of the concerned
                district shall be requisitioned and will undertake the listing
                of contacts. The necessary actions for contact tracing and
                disinfection of work place will start once the report of the
                patient is received as positive. The report will be expedited
                for this purpose.
              </p>
            )}
            <ButtonContainer>
              <CloseButton onClick={handleClosePopupCovid}>Close</CloseButton>
            </ButtonContainer>
          </PopupContent>
        </PopupOverlay>
      )}
      {isPopupVisible && (
        <Popup>
          <PopupText>
            {existingData.groupLeaderName}- Name is exists for this number.
            Click update to save new name or Click cancel
          </PopupText>
          <ButtonContainer>
            <PopupButton onClick={onConfirm}>Update</PopupButton>
            <PopupButton className="no-button" onClick={onClose}>
              Cancel
            </PopupButton>
          </ButtonContainer>
        </Popup>
      )}

      <ToastContainer />
    </Container>
  );
};

export default AppoinmentLeaderFormPage;
